/**
 * @file cardBrand.ts
 * @brief Card-network brand string helpers (no JSX).
 *
 * @details
 * Split out of `CardBrandIcon.tsx` (02-08-2026): that module renders a
 * component, and a module exporting **both** a component and a value loses
 * React Fast Refresh — `@vitejs/plugin-react` can no longer hot-swap it and
 * full-reloads the page on every edit. `EditEmployeeDialog` needs the label
 * without the mark, so the string side lives here.
 *
 * @references
 * - components/CardBrandIcon.tsx
 * - features/employees/components/EditEmployeeDialog.tsx
 *
 * @author DES
 * @date 02-08-2026
 */

/** Stripe brand strings arrive in assorted casings/separators. */
export function normalizeBrand(brand: string): string {
  return brand.toLowerCase().replace(/[\s_-]+/g, "");
}

/** Human-facing network name for a Stripe-style brand string. */
export function formatCardBrand(brand: string): string {
  const b = brand.trim();
  if (!b) return "Card";
  const key = normalizeBrand(b);
  if (key === "visa") return "Visa";
  if (key === "mastercard") return "Mastercard";
  if (key === "amex" || key === "americanexpress") return "Amex";
  return b.charAt(0).toUpperCase() + b.slice(1);
}
